import { render, staticRenderFns } from "./HospitalsList.vue?vue&type=template&id=4f9c44ff&"
import script from "./HospitalsList.vue?vue&type=script&lang=js&"
export * from "./HospitalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports